module.exports = __webpack_public_path__ + "54b818f886f7314b414f573f62c172d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ogs-keno-logo.png
// module id = 576
// module chunks = 0